<template>
  <intersect @enter="animate = true">
    <div
      class="aboutLinkPhotoContainer container fadeUp"
      :class="[marginTop, animate ? 'animate' : '']"
      v-if="itemData"
    >
      <div class="aboutLinkPhoto parallaxe">
        <picture>
          <source
            media="(max-width: 767px)"
            :srcset="_.get(itemData, 'cover_image.0.devices.mobile')"
          />
          <source
            media="(max-width: 1023px)"
            :srcset="_.get(itemData, 'cover_image.0.devices.tablet')"
          />
          <img
            :src="_.get(itemData, 'cover_image.0.devices.desktop')"
            :alt="_.get(itemData, 'title')"
            class="img-absolute"
            v-prlx="{ speed: 0.08 }"
          />
        </picture>
        <div class="mainBannerDescription">
          <div class="ttl">{{ _.get(itemData, "title") }}</div>
          <div class="descr">{{ _.get(itemData, "teaser") }}</div>
          <router-link
            v-if="_.get(itemData, 'smartbuttons')"
            :to="_.get(itemData, 'smartbuttons.0.url')"
            class="noto-semibold mainBlockBtn"
            >{{ _.get(itemData, "smartbuttons.0.title") }}</router-link
          >
        </div>
      </div>
    </div>
  </intersect>
</template>
<script>
import Vue from "vue";
import MainMixin from "@/mixins/main";
import AliMixin from "@/mixins/ali";
import Intersect from "vue-intersect";
import Paralax from "@/assets/js/paralax.js";
Vue.directive("prlx", Paralax);

export default {
  components: { Intersect },
  mixins: [MainMixin, AliMixin],
  data() {
    return {
      animate: false,
    };
  },
  props: {
    itemData: {
      type: Object,
      require: true,
    },
    marginTop: {
      type: String,
    },
  },
  mounted() {
    this.startParralaxe();
  },
  computed: {
    getAboutLinkBanner() {
      return this.$store.getters.getAboutLinkBanner;
    },
  },
};
</script>
